import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CopyIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 18.48 21.5",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 21.5),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M14.1 20.75H2.08a1.33 1.33 0 0 1-1.33-1.33V4.72"
    }), /*#__PURE__*/jsx("rect", {
      height: "17",
      rx: "2",
      width: "14",
      x: "3.73",
      y: ".75"
    })]
  });
};

export { CopyIcon };
//# sourceMappingURL=copy.js.map
